// Emphasis Event View javascript

import { activateOnPage } from '../../utils';

// ========================================
// Manage display of additional dates popup
// ========================================

// Helper function to show the popup by adding the expanded class
function showPopup(container) {
  container.classList.add('em-list_dates__expanded');
}

// Helper function to hide the popup by removing the expanded class
function hidePopup(container) {
  container.classList.remove('em-list_dates__expanded');
}

// Set up event listeners for a single date container
//
// The extra-message element contained within is the triggering element for the popup.
function setupDateContainer(container) {
  const extraMessageEl = container.querySelector('.em-list_dates__extra-message');
  if (!extraMessageEl) return;

  // Track hover and focus state
  let isHovered = false;
  let isFocused = false;

  // Hover behavior: mouseenter shows popup
  extraMessageEl.addEventListener('mouseenter', () => {
    isHovered = true;
    showPopup(container);
  });

  // Hover behavior: mouseleave hides popup unless focused
  extraMessageEl.addEventListener('mouseleave', () => {
    isHovered = false;
    if (!isFocused) {
      hidePopup(container);
    }
  });

  // Focus behavior: focus shows popup
  extraMessageEl.addEventListener('focus', () => {
    isFocused = true;
    showPopup(container);
  });

  // Blur behavior: blur hides popup unless hovered
  extraMessageEl.addEventListener('blur', () => {
    isFocused = false;
    // Use setTimeout to allow focus to move if clicking within container
    setTimeout(() => {
      if (!isHovered) {
        hidePopup(container);
      }
    }, 0);
  });

  // ESC key handler: dismiss popup and return focus to trigger
  extraMessageEl.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && container.classList.contains('em-list_dates__expanded')) {
      event.preventDefault();
      event.stopPropagation();
      hidePopup(container);
      // Return focus to the trigger element
      extraMessageEl.focus();
    }
  });
}

// Initialize all additional dates popups on the page
function initializeAdditionalDatesPopups() {
  const containers = document.querySelectorAll('.em-list_dates__container');
  containers.forEach(setupDateContainer);
}

activateOnPage('event-view', initializeAdditionalDatesPopups);
